import { isNewExperience } from './ExperienceCard';

type ListableExperience = {
    rating?: number | string | null;
    createdAt?: string;
};

const getCreatedAtTime = (createdAt?: string) =>
    createdAt ? new Date(createdAt).getTime() : 0;

const getRating = (rating?: number | string | null) => Number(rating) || 0;

export function sortExperiencesForListing<T extends ListableExperience>(
    experiences: T[],
): T[] {
    return [...experiences].sort((a, b) => {
        const aRating = getRating(a.rating);
        const bRating = getRating(b.rating);
        const aHasRating = aRating > 0;
        const bHasRating = bRating > 0;

        if (aHasRating && bHasRating) {
            if (bRating !== aRating) return bRating - aRating;
            return (
                getCreatedAtTime(b.createdAt) - getCreatedAtTime(a.createdAt)
            );
        }

        if (aHasRating !== bHasRating) {
            return aHasRating ? -1 : 1;
        }

        const aIsNew = isNewExperience(a.createdAt);
        const bIsNew = isNewExperience(b.createdAt);

        if (aIsNew !== bIsNew) {
            return aIsNew ? -1 : 1;
        }

        return getCreatedAtTime(b.createdAt) - getCreatedAtTime(a.createdAt);
    });
}
